import React, { useEffect, useState } from "react";
import Loading from "../general/Loading";
import {
  Button,
  Grid,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import useQueryUrl from "../../helpers/hooks/useQueryUrl";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import CustomerStatementItem from "./CustomerStatementItem";
import { useNavigate } from "react-router-dom";
import PageTitle from "../general/PageTitle"
import DashboardLink from "../general/links/DashboardLink"
import CurrentPage from "../general/links/CurrentPage";
import NavigationLink from "../general/links/NavigationLink";
import ExportPDFButton from "../general/ExportPDFButton";

export default function CustomerStatementReport(){
  // Initialization
  const location = useLocation();
  const param = new URLSearchParams(location.search)
  const filters =  location.search.slice(1);
  const navigate = useNavigate();
  
  console.log(`/customerstatement?${filters}`)
  // Retrieve customer statement data
  const { data = [], isLoading } = useQueryUrl(
    `/customerstatement?${filters}`
  );

  // Render loading if data not done fetching or there is no data
  if (isLoading){
    console.log("isLoading = True");
    return <Loading/>;
  }

  // Excel export function
  function handleExport(){
    // Header to sort columns and filterData to retrieve columns for excel
    const header = ['CardCode', 'DocNum', 'DocDate', 'Original_Amt', 'Open_Balance', 
      'Days_Open', 'CardName', 'Phone1', 'Terms', "ATTN"];
    
    // Filter data and document type then sort by customerCode / CardCode from A-Z
    const filterData = data
      .filter(row => {
        const docType = (row.docType || '').toUpperCase();
        return docType === 'IN' || docType === 'CN';
      })
      .map(row => {
        const docType = (row.docType || '').toUpperCase();
        const isCredit = docType === 'CN' || docType === 'RC' || docType === 'JE' || row.total < 0;
        const rawBalance = row.openBalance !== undefined ? row.openBalance : row.total;
        const balanceDue = isCredit ? -Math.abs(rawBalance) : Math.abs(rawBalance);

        return{
          CardCode: row.customerCode,
          DocNum: row.orderNumber,
          DocDate: row.invoicedDate,
          //Original_Amt: Number(Math.abs(row.total).toFixed(2)),
          Original_Amt: Number(row.total.toFixed(2)),
          Open_Balance: Number(balanceDue.toFixed(2)),
          Days_Open: row.daysOpen,
          CardName: row.customerName,
          Phone1: row.phone,
          Terms: row.paymentGroup,
          ATTN: row.contact,
        };
      }).sort((a, b) => a.CardCode.localeCompare(b.CardCode));

    // Create xlsx worksheet
    const worksheet = XLSX.utils.json_to_sheet(filterData, { header });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Statements");
    XLSX.writeFile(workbook, "CustomerStatementReport.xlsx", { compression: true });
  }

  // Create a key-value pair where the customer code is the key and the values are the customers
  // corresponding name, address, etc. including a list of customer transaction.
  const sortedData = data.reduce((acc, info) => {
    const key = info.customerCode;

    // Normalize type and apply proper credit/debit sign rules
    const docType = (info.docType || '').toUpperCase();
    const isCredit = docType === 'CN' || docType === 'RC' || docType === 'JE' || info.total < 0;
    const adjustedTotal = isCredit ? -Math.abs(info.total) : Math.abs(info.total);
    const adjustedBalance = isCredit ? -Math.abs(info.openBalance) : Math.abs(info.openBalance);

    if (!acc[key]){
      acc[key] = {
        "customerName": info.customerName,
        "shippingAddress": info.shippingAddress,
        "phone": info.phone,
        "fax": info.fax,
        "paymentGroup": info.paymentGroup,
        "creditLimit": info.creditLimit,
        "salesRepName": info.salesRepName,
        "attn": info.contact,
        "customerTransaction": [],
        "totalSum": 0,
        "periodBalance": 0,
      };
    }

    acc[key]["periodBalance"] += Number(adjustedBalance.toFixed(2));
    
    if (docType === 'IN' || docType === 'CN') {
      acc[key]["totalSum"] += Number(adjustedTotal.toFixed(2));

      acc[key]["customerTransaction"].push({
        "type": info.type,
        "docType": info.docType,
        "total": info.total,
        "invoicedDate": info.invoicedDate,
        "daysOpen": info.daysOpen,
        "orderNumber": info.orderNumber,
        "openBalance": info.openBalance,
      });
    }

    return acc; 
  }, {});

  return (
    <>
      {/* Title */}
      <PageTitle title={"Customer Statement Report"}/>
      <div style={{ display: "flex" }}>
        <DashboardLink/>
        <NavigationLink name="Customer Statement" url="/customerstatement" />
        <CurrentPage currentPage={"Customer Statement Report"}/>
      </div>
      <Grid
        container
        alignItems="flex-start"
        justifyContent="flex-start"
        direction="column"
      >
        <Grid container item xs={7} md={9} alignItems="flex-end">
          {/* Handle Customer Statement Excel Output */}
          <Button variant="contained" size="large" sx={{ marginRight: 1.5 }} color="primary" onClick={handleExport}>Export to Excel</Button>

          {/* Handle Customer Statement PDF Output */}
                    <ExportPDFButton 
            fileInfo={Object.fromEntries(param)} 
            fileType={"customerstatementreport"}
          />

          {/* Handle Returning back to the customer statement form */}
          <Button variant="contained" size="large" sx={{ marginRight: 1.5 }} color="secondary" onClick={() => navigate("/customerstatement/")}>Back</Button>

        </Grid>

        <Grid item xs={12} sx={{ mt: 2, width: "100%" }}>
          {/* Output Customer Statement Information */}
          {
            Object.entries(sortedData).map(([customerCode, customerData]) => (
              <div key={customerCode}>
                <CustomerStatementItem
                  customerCode={customerCode}
                  customerData={customerData}
                />
              </div>
            ))
          }
        </Grid>
      </Grid>
    </>
  );
};
